import { useTranslate } from "@refinedev/core";
import { Button } from "@fawkes/ui";

import "./UnderConstruction.css";

// spa-session: shown when the SPA itself ends up handling a not-yet-migrated / unknown route (e.g. a
// deep link to a Jmix screen in a standalone deployment). It keeps the operator inside the app —
// logged in — instead of a full-page navigation that would drop the in-memory token. On-brand,
// friendly placeholder rather than a dead end.
function pathLabel(explicit?: string): string {
  const raw = explicit ?? globalThis.location?.pathname ?? "/";
  const path = raw.replace(/^\/new(?=\/|$)/, "");
  return path && path !== "/" ? path : "/";
}

export function UnderConstruction({ route, onHome }: { route?: string; onHome: () => void }) {
  const t = useTranslate();
  return (
    <div className="under-construction">
      <div className="under-construction__card">
        <div className="under-construction__art" aria-hidden="true">
          {/* A paw under a little traffic cone — playful nod to the shelter domain + "in aanbouw". */}
          <svg viewBox="0 0 120 120" width="120" height="120" role="img">
            <circle cx="60" cy="60" r="56" className="uc-art__halo" />
            {/* traffic cone */}
            <path d="M60 30 L74 78 H46 Z" className="uc-art__cone" />
            <rect x="44" y="78" width="32" height="8" rx="3" className="uc-art__cone-base" />
            <rect x="52" y="48" width="16" height="5" rx="2.5" className="uc-art__cone-stripe" />
            <rect x="49" y="60" width="22" height="5" rx="2.5" className="uc-art__cone-stripe" />
            {/* paw print */}
            <g className="uc-art__paw">
              <ellipse cx="90" cy="84" rx="9" ry="11" />
              <circle cx="80" cy="72" r="4.2" />
              <circle cx="90" cy="68" r="4.2" />
              <circle cx="100" cy="72" r="4.2" />
            </g>
          </svg>
        </div>

        <h1 className="under-construction__heading">{t("underConstruction.heading")}</h1>
        <p className="under-construction__body">{t("underConstruction.body")}</p>

        <div className="under-construction__route">
          <span className="under-construction__route-label">{t("underConstruction.routeLabel")}</span>
          <code className="under-construction__route-value">{pathLabel(route)}</code>
        </div>

        <Button variant="primary" onClick={onHome} className="under-construction__home">
          {t("underConstruction.home")}
        </Button>
      </div>
    </div>
  );
}
